import { render, staticRenderFns } from "./DesignConfigSaveComponent.vue?vue&type=template&id=e42643ae&"
import script from "./DesignConfigSaveComponent.vue?vue&type=script&lang=js&"
export * from "./DesignConfigSaveComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports